import apiFetch from './client';

export const getTimerHistory = () =>
  apiFetch('/api/users/me/timer-history');

export const saveTimerHistory = (history) =>
  apiFetch('/api/users/me/timer-history', {
    method: 'PUT',
    body: JSON.stringify({ history }),
  });
